module.exports = __webpack_public_path__ + "static/img/th-crads-technical2-07.5936c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crads-technical2-07.png
// module id = t2V9
// module chunks = 1